import type { SVGProps } from "react";
const SvgChevronDown = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M629.293 88.2929C629.683 87.9024 630.317 87.9024 630.707 88.2929L636 93.5858L641.293 88.2929C641.683 87.9024 642.317 87.9024 642.707 88.2929C643.098 88.6834 643.098 89.3166 642.707 89.7071L636.707 95.7071C636.317 96.0976 635.683 96.0976 635.293 95.7071L629.293 89.7071C628.902 89.3166 628.902 88.6834 629.293 88.2929Z"
      fill="currentColor"
      transform="translate(-624 -80)"
    />
  </svg>
);
export default SvgChevronDown;
